import { getTitleEnumValue } from '@/functions';
import { TableCell } from '@/components/ui';
import { GenderEnum } from '@/lib/enum';
import { cn } from '@/lib/utils';

type TProps = {
  gender: GenderEnum;
}

export const DataTableBodyCellGender = ({ gender }: TProps) => (
  <TableCell className={
    cn(
      'py-1 pe-0 w-0',
      gender === GenderEnum.MALE
        ? 'text-blue-500'
        : 'text-red-500'
    )
  }>
    {getTitleEnumValue('GenderEnum', gender)}
  </TableCell>
);

export default DataTableBodyCellGender;
